/**
 * 腾讯地图key配置
 * @see https://lbs.qq.com/dev/console/key/manage
 */
const tencentMapKeys = key => {
    let appKey = ''; // key
    let keyName = ''; // key名称
    let callbackName = '';
    let scriptUrl = ''; // 要加载的脚本

    switch (key) {
        case 'siteCodeMap': // 场所码 地图（没用到
            appKey = '66LBZ-VOFCW-UXNRO-RDPLZ-O23UF-OMFMJ';
            keyName = 'siteCode';
            callbackName = 'onMapCallback';
            scriptUrl = `https://map.qq.com/api/gljs?v=1.exp&libraries=geometry&key=${appKey}&callback=${callbackName}`; // libraries按需

            return { appKey, keyName, scriptUrl, callbackName };
        case 'siteCodeGeo': // 场所码 定位
            appKey = '66LBZ-VOFCW-UXNRO-RDPLZ-O23UF-OMFMJ';
            keyName = 'siteCode';

            return { appKey, keyName };
        default:
            return {};
    }
};

/**
 * 腾讯地图 异步初始化Map
 * @see https://lbs.qq.com/webApi/javascriptGL/glGuide/glBasic
 * @use 
 *    1.计算两点之间直线距离（scriptUrl里libraries依赖+geometry 几何计算库
 *    asyncInitTencentMap(对应的keyName).then((TMap) => {
        const startPoint = new TMap.LatLng(31.777927, 117.277849);
        const endPoint = new TMap.LatLng(31.769675, 117.274707);
        const path = [startPoint, endPoint];
        // 计算路径的实际距离
        const distance = TMap.geometry.computeDistance(path);
      });
 */
const asyncInitTencentMap = function(key) {
    const { scriptUrl = '', callbackName = '' } = tencentMapKeys(key);

    return new Promise((resolve, reject) => {
        if (typeof TMap !== 'undefined') {
            resolve(TMap);
            return true;
        }

        // 异步回调处理
        if (callbackName) {
            window[callbackName] = function() {
                resolve(TMap);
            };
        }

        // 动态加载script脚本
        const scriptNodeMap = document.createElement('script');
        scriptNodeMap.setAttribute('type', 'text/javascript');
        scriptNodeMap.setAttribute('src', scriptUrl);
        document.body.appendChild(scriptNodeMap);
    });
};

/**
 * 角度转弧度
 * @param {*} n 角度
 * @returns 弧度
 */
const rad = function(n) {
    return n * Math.PI / 180.0;
};

/**
 * 计算两点间直线距离（和腾讯api计算结果基本一致
 * @return 距离，单位m，保留到整数位
 */
const calcDistance = function(latFrom, lngFrom, latTo, lngTo) {
    const EARTH_RADIUS = 6378136.49; // 赤道半径，m

    const radLatFrom = rad(latFrom);
    const radLngFrom = rad(lngFrom);
    const radLatTo = rad(latTo);
    const radLngTo = rad(lngTo);

    const diffLat = radLatFrom - radLatTo; // 纬度差
    const diffLng = radLngFrom - radLngTo; // 经度差

    let distance =
        2 *
        Math.asin(
            Math.sqrt(
                Math.pow(Math.sin(diffLat / 2), 2) +
                    Math.cos(radLatFrom) *
                        Math.cos(radLatTo) *
                        Math.pow(Math.sin(diffLng / 2), 2)
            )
        );

    // 弧长L = n×π/180 ×r = rad x r
    distance = distance * EARTH_RADIUS;
    // distance = Math.round(distance * Math.pow(10, 13)) / Math.pow(10, 13);
    distance = parseFloat(distance.toFixed(0));

    return distance;
};

export { tencentMapKeys, asyncInitTencentMap, rad, calcDistance };



// WEBPACK FOOTER //
// ./src/util/map.js